export default "__VITE_ASSET__b18b1a82__"